export function WellBeing(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0C2.68629 0 0 2.68629 0 6V18C0 21.3137 2.68629 24 6 24H18C21.3137 24 24 21.3137 24 18V6C24 2.68629 21.3137 0 18 0H6ZM8.92969 17.8125C8.02344 17.8125 7.375 17.4453 7.0625 16.3281L5.10938 9.45312C5 9.07031 4.94531 8.67969 4.94531 8.42188C4.94531 7.57812 5.54688 7 6.42969 7C7.25 7 7.71875 7.5 7.96875 8.64844L9.10156 13.7578H9.24219L10.4766 8.58594C10.7578 7.45312 11.1953 7 12.0234 7C12.8516 7 13.3203 7.47656 13.5859 8.58594L14.8281 13.7578H14.9766L16.0312 8.64844C16.25 7.52344 16.7578 7 17.5859 7C18.4531 7 19.0547 7.57031 19.0547 8.39062C19.0547 8.65625 19.0078 9.03125 18.9453 9.24219L16.9922 16.3281C16.7109 17.3281 16.1328 17.8125 15.2109 17.8125C14.2344 17.8125 13.6016 17.3438 13.3125 16.2344L12.0859 11.6094H11.9766L10.7266 16.3281C10.4766 17.2812 9.82812 17.8125 8.92969 17.8125Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
